import script from "./CompanyView.vue?vue&type=script&setup=true&lang=js"
export * from "./CompanyView.vue?vue&type=script&setup=true&lang=js"

import "./CompanyView.vue?vue&type=style&index=0&id=2ee46b38&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2ee46b38"]])

export default __exports__